import React from 'react';

import { BottomSheet } from './BottomSheet';

type ConfirmSheetProps = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  destructive?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmSheet({
  open,
  title,
  message,
  confirmLabel = 'Подтвердить',
  destructive = false,
  onCancel,
  onConfirm,
}: ConfirmSheetProps) {
  return (
    <BottomSheet open={open} title={title} onClose={onCancel}>
      <div className="ttbConfirmMessage">{message}</div>
      <div className="ttbConfirmActions">
        <button
          type="button"
          onClick={onCancel}
          className="ttbButton ttbConfirmButton ttbConfirmCancel"
        >
          Отмена
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={
            [
              'ttbButton',
              'ttbConfirmButton',
              'ttbConfirmConfirm',
              destructive ? 'ttbConfirmConfirmDestructive' : null,
            ]
              .filter(Boolean)
              .join(' ')
          }
        >
          {confirmLabel}
        </button>
      </div>
    </BottomSheet>
  );
}
